import api from '../api';
const root = '/tasks/notes/';
export const loadTree = signal => api.get(root, { signal }).then(r => r.data);
export const loadNote = (id, signal) => api.get(root + id + '/', { signal }).then(r => r.data);
export const create = data => api.post(root, data).then(r => r.data);
export const update = (id, data) => api.patch(root + id + '/', data).then(r => r.data);
export const remove = id => api.delete(root + id + '/');
export const reorder = nodes => api.post(root + 'reorder/', { nodes });
export function message(e) { const data = e.response?.data; return typeof data?.error === 'string' ? data.error : typeof data?.detail === 'string' ? data.detail : 'Не удалось сохранить. Проверьте подключение и повторите.'; }
